const chartSel = "[data-size-chart]";

const setUnitState = (chartEl, unit) => {
  const showCm = unit === "cm";
  const convRows = chartEl.querySelectorAll('[data-size-chart-convertible="true"]');
  const inVals = [];
  const cmVals = [];
  const togBtns = chartEl.querySelectorAll("[data-size-chart-toggle]");
  const copyEl = chartEl.querySelector("[data-size-chart-copy]");

  for (const rowEl of convRows) {
    inVals.push(...rowEl.querySelectorAll("[data-size-chart-in]"));
    cmVals.push(...rowEl.querySelectorAll("[data-size-chart-cm]"));
  }

  for (const inVal of inVals) {
    inVal.classList.toggle("hidden", showCm);
  }

  for (const cmVal of cmVals) {
    cmVal.classList.toggle("hidden", !showCm);
  }

  for (const btn of togBtns) {
    const isActive = btn.dataset.sizeChartUnitValue === unit;
    btn.classList.toggle("sizeChart__toggleButton--active", isActive);
    btn.setAttribute("aria-pressed", String(isActive));
  }

  if (!copyEl) return;

  const nextCopy = showCm ? chartEl.dataset.cmCopy : chartEl.dataset.inchCopy;
  copyEl.textContent = nextCopy || "";
};

const initSizeChart = chartEl => {
  if (!chartEl) return;

  const startUnit = chartEl.dataset.sizeChartUnit === "cm" ? "cm" : "in";
  setUnitState(chartEl, startUnit);

  chartEl.addEventListener("click", event => {
    const toggleBtn = event.target.closest("[data-size-chart-toggle]");
    if (!toggleBtn || !chartEl.contains(toggleBtn)) return;

    const nextUnit = toggleBtn.dataset.sizeChartUnitValue === "cm" ? "cm" : "in";
    chartEl.dataset.sizeChartUnit = nextUnit;
    setUnitState(chartEl, nextUnit);
  });
};

const initSizeCharts = () => {
  const chartEls = document.querySelectorAll(chartSel);
  for (const chartEl of chartEls) {
    initSizeChart(chartEl);
  }
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSizeCharts);
} else {
  initSizeCharts();
}
